import React from 'react';
import { Field, FastField } from 'formik';
import DateTimeField from 'customField/DateTimeField';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string} props.placeholder
 * @param {(date) => void} props.afterOnChange
 * @param {boolean} props.disableSelectTime
 * @param {boolean} props.isClearable
 * @param {string} props.classNameContainer
 * @returns
 */
const DateTime = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={DateTimeField} {...props} />;
};

export default DateTime;
